var TitleView = Backbone.View.extend({
    el: 'title',
    initialize: function (options) {
        this.model.buffers.bind('unseenHighlightChange', this.render, this);
        this.model.connections.bind('change:name', this.connectionChange, this);
        this.model.connections.bind('change:hostname', this.connectionChange, this);
        this.model.connections.bind('twitchChannelChange', this.connectionChange, this);
        this.model.connections.bind('urlPropChange', this.connectionChange, this);
        this.model.bind('unseenChange', this.render, this);
        this.model.bind('currentBufferChange', this.render, this);
        this.model.bind('streamConnectedChange', this.render, this);
    },
    getUnseenMessageStats: function () {
        if (!this.model.unseenBuffers.length) {
            return false;
        }
        var count = 0;
        this.model.unseenBuffers.each(function (buffer) {
            count += buffer.unseenHighlightCount();
        }, this);
        return count;
    },
    connectionChange: function (connection) {
        if (!connection.isSelected()) {
            return;
        }
        this.render();
    },
    
    render: function () {
        var title = 'IRCCloud';
        var entName = this.model.ent('fullname');
        if (entName) {
            title += ': ' + entName;
        }
        var current = this.model.currentBuffer;
        if (current) {
            title = current.connection.getName();
            if (!current.isServerLog()) {
                var displayName = current.getDisplayName();
                if (current.isChannel()) {
                    var twitchInfo = current.getTwitchInfo();
                    if (twitchInfo && twitchInfo.channel.display_name) {
                        displayName = twitchInfo.channel.display_name;
                    }
                }
                title = displayName + ' | ' + title;
            }
        }
        var stats = this.getUnseenMessageStats();
        
        // Fluid badge
        var dockBadge = '';
        if (stats) {
            dockBadge += stats;
        }
        if (window.fluid) {
            window.fluid.dockBadge = dockBadge;
        }
        if (window.macgap) {
            window.macgap.dock.badge = dockBadge;
        }
        if (navigator.setExperimentalAppBadge) {
            navigator.setExperimentalAppBadge(dockBadge);
        }
        if (window.ExperimentalBadge) {
            window.ExperimentalBadge.set(dockBadge);
        }
        
        if (stats !== false) {
            if (stats) {
                title = '(' + stats + ') ' + title;
            } else if (current && current.isTrackingUnread() && current.hasUnseen()) {
                title = '+ ' + title;
            } else {
                title = '* ' + title;
            }
        }
        if (this.model.isAuthed() && !this.model.isStreamConnected() && !this.model.backend.unloading) {
            title = '(Offline) ' + title;
        }
        this.setTitle(title);
        // Reset after a delay. Hack needed for windows chrome
        if (this.titleDelay) {
            clearTimeout(this.titleDelay);
        }
        this.titleDelay = setTimeout(_.bind(function () {
            this.titleDelay = null;
            this.setTitle('');
            this.setTitle(title);
        }, this), TitleView.titleDelay);
    },
    setTitle: function (title) {
        document.title = title;
    },
}, {
    titleDelay: 500,
});


module.exports = TitleView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/titleview.js
// module id = XLeX
// module chunks = 1